<template>
  <section
    class="banner bgs-cover w-100p t-0"
    :class="isFixed ? 'p-fix' : 'p-r'"
    :style="{ backgroundImage: `url(${bannerImg})` }"
  >
    <div class="crumb d-f jc-fs ai-c ff-asl in-pc">
      <nuxt-link class="c-fff" to="/">Home</nuxt-link>
      <span class="c-fff"></span>
      <nuxt-link class="c-fff" to="/product">Product</nuxt-link>
      <span class="c-fff"></span><a class="c-fff">{{ productName }}</a>
    </div>
    <!-- crumb:end -->
    <div class="banner-content c-fff p-a" :style="customStyle">
      <div class="p-r ov-h">
        <!-- 如果不是俩行或者三行得格式将采取插槽形式 -->
        <span v-if="$slots.default"><slot></slot></span>
        <div v-else>
          <!-- 三行内容需要固定并有滚动特效 -->
          <div v-if="isScroll">
            <h1 id="banner-title-1" class="banner-title m-0">
              <span class="d-b tt-u fw-700">{{ mainTitle }}</span>
              <i class="d-b tt-u fw-500">{{ subTitle }}</i>
            </h1>
            <h1 id="banner-title-2" class="banner-title m-0 p-a l-0">
              <i class="d-b fw-500">{{ slogan }}</i>
            </h1>
          </div>
          <div v-else>
            <h1 class="banner-title m-0 tt-u">
              <span class="d-b fw-700">{{ mainTitle }}</span>
              <i class="d-b fw-500">{{ subTitle }}</i>
            </h1>
          </div>
        </div>
      </div>
      <div v-if="$slots.dealer"><slot name="dealer"></slot></div>
      <nuxt-link v-else to="/dealer" target="_blank" class="banner-btn d-ib ta-c">{{
        $t('common.common.ContactUs')
      }}</nuxt-link>
    </div>
    <!-- 产品图 -->
    <i :style="productImgStyle" class="banner-product-img d-b p-a bgs-cover"></i>
  </section>
</template>

<script>
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
  export default {
    props: {
      bannerImg: {
        type: String,
        default: ''
      },
      // 产品名
      productName: {
        type: String,
        default: ''
      },
      // 产品图片样式
      productImgStyle: {
        type: Object,
        default: () => {}
      },
      // 自定义样式 比如控制 banner-connect 位置
      customStyle: {
        type: Object,
        default: () => {}
      },
      // 是否滚动交互动画
      isScroll: {
        type: Boolean,
        default: false
      },
      // banner 内容
      bannerContent: {
        type: Object,
        default: () => {}
      },
      isFixed: {
        type: Boolean,
        default: false
      },
      // 主标题
      mainTitle: {
        type: String,
        default: ''
      },
      // 副标题
      subTitle: {
        type: String,
        default: ''
      },
      //
      slogan: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },
    created() {},
    mounted() {
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (process.browser) {
        gsap.registerPlugin(ScrollTrigger)
        this.bannerAnimate()
      }
      console.log(this.$slots)
    },
    methods: {
      bannerAnimate() {
        // eslint-disable-next-line no-undef
        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.banner-content',
              start: 0,
              end: '+=100',
              duration: 1.5,
              scrub: 1
              // markers: true
            }
          })
          .to('#banner-title-1', {
            opacity: 0,
            y: '-80%',
            duration: 1
          })
          .to('#banner-title-2', {
            opacity: 1,
            y: '0',
            duration: 1
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  /* banner */
  .banner {
    margin-top: 0.76rem;
    height: 8rem;
  }
  .banner .crumb {
    padding-top: 0.34rem;
    padding-left: 0.66rem;
    font-size: 0.16rem;
    display: flex;
    align-items: center;
    line-height: 1;
  }
  .banner .crumb span {
    height: 0.13rem;
  }
  .banner .crumb a:hover {
    color: #fff;
  }

  .banner-content {
    top: 3rem;
    left: 2rem;
    width: 80%;
  }
  .banner-title {
    transition: all 0.1s linear;
  }
  .banner-title span {
    font-size: 0.64rem;
    line-height: 1.1;
    margin-bottom: 0.16rem;
  }
  .banner-title i,
  .banner-desc {
    font-size: 0.48rem;
  }

  .banner-btn {
    margin-top: 0.48rem;
    padding: 0 0.32rem;
    font-size: 0.2rem;
    line-height: 0.48rem;
    color: rgba(0, 0, 0, 0.85);
    background: rgba(255, 255, 255, 0.65);
    transition: background-color 0.3s linear;
  }
  .banner-btn:hover {
    background: rgba(255, 255, 255, 0.75);
  }

  #banner-title-2 {
    top: 0.7rem;
    transform: translateY(100%);
    opacity: 0;
  }

  .banner-product-img {
    // width: 2.41rem;
    // height: 2.95rem;
    // top: 4.83rem;
    // right: 1.8rem;
  }
</style>
